const activityType = {
  course: 'Cours',
  language: 'Langues',
  event: 'Évènement',
};

export default activityType;
